export default function () {
  const moduleName = 'sticky'
  Array.from(document.querySelectorAll('.js-sticky')).forEach((wrapper) => {
    if (wrapper.dataset[moduleName + 'Init'] === 'true') return
    wrapper.dataset[moduleName + 'Init'] = 'true'

    const element = wrapper.querySelector('.js-sticky-element')
    let fakeBlock

    init()
    /// /////////////////////////////

    window.addEventListener('load', sticky)
    window.addEventListener('scroll', sticky)
    window.addEventListener('resize', sticky)

    window.onbeforeprint = () => fakeBlock.style.display = 'none'
    window.onafterprint = () => fakeBlock.style.display = 'block'

    function init () {
      createFakeBlock()
      sticky()
    }

    function createFakeBlock () {
      fakeBlock = document.createElement('div')
      wrapper.before(fakeBlock)
    }

    function sticky () {
      const scrollTop = (document.documentElement.scrollTop || document.body.scrollTop)
      const offsetTopElement = element.getBoundingClientRect().top + (document.documentElement.scrollTop || document.body.scrollTop)
      const offsetTopFakeBlock = fakeBlock.getBoundingClientRect().top + (document.documentElement.scrollTop || document.body.scrollTop)
      const elementHeight = element.offsetHeight
      const fakeBlockHeight = element.offsetHeight

      if (wrapper.classList.contains('sticky')) {
        if (scrollTop < (offsetTopFakeBlock + fakeBlockHeight)) {
          wrapper.classList.remove('sticky')

          fakeBlock.style.height = '0'
        }
      } else {
        if (scrollTop > (offsetTopElement + elementHeight)) {
          wrapper.classList.add('sticky')

          fakeBlock.style.height = elementHeight + 'px'
        }
      }
    }
  })
};
